export default {
  // 系統管理
  'menu.system': '系統管理',
  'menu.system.user': '用戶管理',
  'menu.system.role': '角色管理',
  'menu.system.menu': '選單管理',
  'menu.system.dept': '部門管理',

  // 監控管理
  'menu.monitor': '監控管理',
  'menu.monitor.login-log': '登入日誌',
  'menu.monitor.oper-log': '操作日誌',

  // 登入
  'menu.login': '登入',
};
